import { TextField, Typography } from '@mui/material'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { ErrorLogger } from '../../../utils/Logger';
import { useState } from 'react'
import GGLoaderButton from '../../../components/CommonComponents/GGLoaderButton/GGLoaderButton';
import { SessionManager } from '../../../services/SessionManager/SessionManager';
import { FeedbackAPIHandler } from '../../../services/NetworkClient/BackendAPIs/FeedbackAPIHandler';
import successLottie from '../../../assets/lottie_animations/success-lottie.json';
import Lottie from 'lottie-react';

enum FeedbackTileTypeEnum {
    bad = 2,
    average = 3,
    like = 4,
    love = 5
}

const SellerWorkspaceFeedbackBlock = () => {
    const [selectedTile, setSelectedTile] = useState<FeedbackTileTypeEnum | undefined>(undefined);
    const [remarks, setRemarks] = useState("");
    const [isLoading, setIsloading] = useState(false);
    const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

    const submitFeedback = async () => {
        try {
            setIsloading(true)
            const feedbackData = {
                comments: remarks,
                rating: selectedTile,
                userId: SessionManager.shared.buyer?.id,
                submittedByUserType: "freelancer"
            }

            const submissionSuccess = await FeedbackAPIHandler.shared.postGGReview(feedbackData);
            if (submissionSuccess) {
                setFeedbackSubmitted(true)
            } else {
                throw new Error("Something went wrong")
            }

        } catch(error) {
            ErrorLogger.log(error, 'SellerWorkspaceFeedbackBlock.submitFeedback');
        } finally {
            setIsloading(false)
        }

    }

    return (
        <div className="feedback-div">
            {feedbackSubmitted ?
                <>
                    <Lottie className="success-lottie" animationData={successLottie} loop={true} ></Lottie>
                    <Typography fontSize={"24px"} fontWeight={500}> Your feedback has been submitted successfully!</Typography>
                </> :
                <>
                    <Typography className="feedback-question">How did you like the experience till now?</Typography>
                    <div className="feedback-tiles-section">
                        <div onClick={() => setSelectedTile(FeedbackTileTypeEnum.bad)} className={selectedTile === FeedbackTileTypeEnum.bad ? "feedback-tile bad selected" : "feedback-tile bad"}>
                            <SentimentVeryDissatisfiedIcon className="feedback-tile-icon bad" />
                            <Typography className="feedback-tile-text bad">Bad</Typography>
                        </div>
                        <div onClick={() => setSelectedTile(FeedbackTileTypeEnum.average)} className={selectedTile === FeedbackTileTypeEnum.average ? "feedback-tile average selected" : "feedback-tile average"}>
                            <SentimentDissatisfiedIcon className="feedback-tile-icon average" />
                            <Typography className="feedback-tile-text average">Average</Typography>
                        </div>
                        <div onClick={() => setSelectedTile(FeedbackTileTypeEnum.like)} className={selectedTile === FeedbackTileTypeEnum.like ? "feedback-tile like selected" : "feedback-tile like"}>
                            <ThumbUpOffAltIcon className="feedback-tile-icon like" />
                            <Typography className="feedback-tile-text like">Like it</Typography>
                        </div>
                        <div onClick={() => setSelectedTile(FeedbackTileTypeEnum.love)} className={selectedTile === FeedbackTileTypeEnum.love ? "feedback-tile love selected" : "feedback-tile love"}>
                            <FavoriteBorderIcon className="feedback-tile-icon love" />
                            <Typography className="feedback-tile-text love">Love it</Typography>
                        </div>
                    </div>
                    <TextField value={remarks} onChange={(e) => setRemarks(e.target.value)} className="feedback-textarea" id="outlined-multiline-static" multiline fullWidth rows={2.5} placeholder="What would you like us to improve on?..." />
                    <GGLoaderButton onClick={submitFeedback} circularProgressColorHex='#bcbcbc' className="submit-feedback-btn" variant="outlined" isLoading={isLoading}> Submit Feedback </GGLoaderButton>
                </>
            }

        </div>
    )
}

export default SellerWorkspaceFeedbackBlock